export const CUIT_LENGTH = 11

const WEIGHTS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]

// El dígito verificador solo no alcanza: "00000000000" lo cumple.
const CUIT_TYPE_PREFIXES = new Set(['20', '23', '24', '25', '26', '27', '30', '33', '34'])

export const normalizeCUIT = value => `${value ?? ''}`.replace(/\D/g, '')

// Mismo criterio que api/src/lib/validateCUIT (validateCUIT.all): con resto 1
// el dígito verificador válido es 9 (masculino/empresa) o 4 (femenino).
const expectedCheckDigits = digits => {
  const sum = WEIGHTS.reduce((total, weight, index) => total + weight * digits[index], 0)
  const remainder = sum % 11
  if (remainder === 0) return [0]
  if (remainder === 1) return [9, 4]
  return [11 - remainder]
}

export const isValidCUIT = value => {
  const cuit = normalizeCUIT(value)
  if (cuit.length !== CUIT_LENGTH || !CUIT_TYPE_PREFIXES.has(cuit.slice(0, 2))) return false

  const digits = cuit.split('').map(Number)
  return expectedCheckDigits(digits).includes(digits[CUIT_LENGTH - 1])
}

export const formatTaxAddress = address => {
  if (!address) return ''
  const street = [address.street, address.floor].filter(Boolean).join(' ')
  const locality = [address.city, address.state].filter(Boolean).join(', ')
  const zipCode = address.zipCode ? `(${address.zipCode})` : ''
  return [street, [locality, zipCode].filter(Boolean).join(' ')].filter(Boolean).join(' — ')
}
